import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {Header} from '../../common/header'
import {SlideInModal} from '../../slide-in-modal'
import {Ticket} from '../ticket'
import {classes} from './ticket-description.st.css'
import {TicketDescriptionProps} from './index'

export const TicketDescription = ({show, place, onClose}: TicketDescriptionProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  return (
    <SlideInModal
      id="ticket-description"
      className={isMobile ? undefined : classes.desktopSlideInModal}
      show={show}
      fromBottom={isMobile}
      onBackClick={isMobile ? undefined : onClose}
      backButtonText={isMobile ? undefined : t('seatings_moreInfo_backToBasket')}
    >
      <div>
        <Header
          className={isMobile ? undefined : classes.desktopHeader}
          titleClassName={isMobile ? undefined : classes.desktopTitle}
          title={t('seatings_moreInfo_title')}
          closeModal={isMobile ? onClose : null}
        />
        <div className={classes.content}>
          {place ? <Ticket inDescription={true} place={place} /> : null}
          <Text tagName="p" className={classes.description}>
            {place?.ticket?.description}
          </Text>
        </div>
      </div>
    </SlideInModal>
  )
}
